import { CartLinesUpdateEvent } from '@shopify/events';

const config = document.querySelector('#iam-christmas-shop-config');
const root = window.Shopify?.routes?.root || '/';
const modal = document.querySelector('#iam-christmas-quick-add');
const cache = new Map();
const catalogPromise = fetch(config.dataset.catalog).then(r => {
  if (!r.ok) throw new Error('Catalog unavailable');
  return r.json();
});
const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(cents / 100);
const productURL = handle => `${root}products/${encodeURIComponent(handle)}`;
const productData = handle => {
  if (!cache.has(handle)) cache.set(handle, fetch(`${productURL(handle)}.js`).then(r => {if (!r.ok) throw new Error(config.dataset.error); return r.json();}).catch(e => {cache.delete(handle);throw e;}));
  return cache.get(handle);
};

function image(src, name, alt = '') {
  const el = document.createElement('img');
  el.src = `${src}${src.includes('?') ? '&' : '?'}width=900`;
  el.className = name;
  el.alt = alt;
  el.width = 1254;
  el.height = 1254;
  el.decoding = 'async';
  return el;
}

function showOriginalPrint(art, originalColor, color) {
  return !!art && art.includes('iam-christmas-swatch-') && originalColor === color;
}

function makePhoto(item, color, catalog) {
  const photo = document.createElement('div');
  photo.className = 'iam-christmas-photo';
  photo.dataset.artwork = item.art;
  photo.dataset.originalColor = item.original_color;
  photo.dataset.photo = item.photo;
  photo.dataset.color = color;
  const rug = image(catalog.rug,'iam-christmas-photo__rug');
  rug.src = `${catalog.rug}&width=720`;
  photo.append(rug);
  const original = showOriginalPrint(item.art, item.original_color, color);
  photo.append(image(item.art && !original ? catalog.bases[color] : item.photo,'iam-christmas-photo__shirt',item.title));
  if (item.art && item.geometry) {
    const svgNS = 'http://www.w3.org/2000/svg';
    const art = document.createElementNS(svgNS,'svg');
    const source = document.createElementNS(svgNS,'image');
    art.setAttribute('class','iam-christmas-photo__art');
    art.setAttribute('viewBox',item.geometry.viewbox.join(' '));
    art.setAttribute('preserveAspectRatio','xMidYMin meet');
    art.setAttribute('aria-hidden','true');
    art.setAttribute('focusable','false');
    if (original) art.style.display = 'none';
    ['left','top','width','height'].forEach((key,i)=>art.style[key]=`${item.geometry.box[i]}%`);
    source.setAttribute('href',`${item.art}&width=900`);
    source.setAttribute('width',item.geometry.source[0]);
    source.setAttribute('height',item.geometry.source[1]);
    art.append(source);
    photo.append(art);
  }
  return photo;
}

async function updatePhoto(container, color) {
  const gallery = container.querySelector('[data-cw-gallery]');
  if (gallery) {
    const product = container.querySelector('form').product;
    const variant = product.variants.find(v => v.option1 === color && v.featured_image);
    if (variant) {
      const img = gallery.querySelector('img');
      img.removeAttribute('srcset');
      img.src = variant.featured_image.src;
      img.alt = product.title + ' – ' + color;
      const caption = container.querySelector('[data-iam-color-label]');
      if (caption) caption.textContent = color;
    }
    return;
  }
  const catalog = await catalogPromise;
  const photo = container.querySelector('.iam-christmas-photo');
  if (!photo) return;
  photo.dataset.color = color;
  if (photo.dataset.artwork) {
    const original = showOriginalPrint(photo.dataset.artwork, photo.dataset.originalColor, color);
    const url = original ? photo.dataset.photo : catalog.bases[color];
    const shirt = photo.querySelector('.iam-christmas-photo__shirt');
    const src = url + '&width=900';
    if (shirt.getAttribute('src') !== src) shirt.src = src;
    const print = photo.querySelector('.iam-christmas-photo__art');
    if (print) print.style.display = original ? 'none' : '';
  }
  const label = container.querySelector('[data-iam-color-label]');
  if (label) label.textContent = photo.dataset.artwork || photo.dataset.originalColor === color ? color : `${color} · ${config.dataset.shown} ${photo.dataset.originalColor}`;
}

function selectedVariant(form, product) {
  return product.variants.find(v => v.option1 === form.elements.color.value && v.option2 === form.elements.size?.value);
}

function setupForm(container, product, color) {
  const form = container.querySelector('[data-iam-buy]');
  form.product = product;
  form.elements.color.value = color;
  const sizeOptions = form.querySelector('[data-iam-size-options]');
  sizeOptions.replaceChildren();
  const styles = ['Infant tee','Toddler tee','Youth tee'];
  const productStyles = [...new Set(product.variants.map(v=>v.option3).filter(Boolean))];
  const orderedStyles = [...styles.filter(s=>productStyles.includes(s)),...productStyles.filter(s=>!styles.includes(s))];
  for (const style of orderedStyles.length ? orderedStyles : ['']) {
    const group = document.createElement('div');
    group.className = 'iam-christmas-size-group';
    if (style) {
      const heading = document.createElement('span');
      heading.className = 'iam-christmas-size-heading';
      heading.textContent = style;
      group.append(heading);
    }
    const choices = document.createElement('div');
    choices.className = 'iam-christmas-size-choices';
    for (const size of new Set(product.variants.filter(v => !style || v.option3 === style).map(v => v.option2))) {
      const label = document.createElement('label');
      label.className = 'iam-christmas-choice';
      const input = document.createElement('input');
      input.type = 'radio'; input.name = 'size'; input.value = size; input.required = true;
      const text = document.createElement('span');
      text.textContent = size.replace('MOS','m');
      label.append(input,text);
      choices.append(label);
    }
    group.append(choices);
    sizeOptions.append(group);
  }
  sizeOptions.setAttribute('aria-busy','false');
  const sync = () => {
    for (const option of form.querySelectorAll('[name="size"]')) {
      option.disabled = !product.variants.some(v=>v.option1===form.elements.color.value && v.option2===option.value && v.available);
    }
    const variant = selectedVariant(form,product);
    const button = form.querySelector('[type="submit"]');
    button.disabled = Boolean(form.dataset.busy) || !variant || !variant.available;
    button.textContent = form.dataset.busy ? config.dataset.adding : variant && !variant.available ? config.dataset.unavailable : variant ? config.dataset.add : config.dataset.size;
    container.querySelector('[data-iam-price]').textContent = money(variant?.price ?? product.price);
    if (form.elements.id && variant) form.elements.id.value = variant.id;
    const details = container.querySelector('[data-iam-details]');
    if (details) details.href = `${productURL(product.handle)}?${variant ? `variant=${variant.id}` : `color=${encodeURIComponent(form.elements.color.value)}`}`;
    updatePhoto(container,form.elements.color.value).catch(()=>{});
  };
  form.onchange = sync;
  sync();
}

async function openQuick(card, initialColor) {
  const title = modal.querySelector('h2');
  const form = modal.querySelector('form');
  form.reset();
  form.product = null;
  form.onchange = null;
  const color = initialColor || card.querySelector('[name="color"]:checked')?.value || card.dataset.color;
  const sizeOptions = form.querySelector('[data-iam-size-options]');
  sizeOptions.replaceChildren();
  sizeOptions.setAttribute('aria-busy','true');
  form.querySelector('[type="submit"]').disabled = true;
  form.querySelector('[type="submit"]').textContent = config.dataset.size;
  form.querySelector('[data-iam-error]').textContent = '';
  title.textContent = card.querySelector('h1, h3').textContent;
  modal.querySelector('[data-iam-price]').textContent = card.querySelector('.iam-christmas-card__price, [data-iam-price]').textContent;
  const photo = card.querySelector('[data-cw-gallery], .iam-christmas-photo, .iam-christmas-card__image img');
  const frame = modal.querySelector('[data-iam-modal-photo]');
  frame.replaceChildren();
  if (photo) frame.append(photo.cloneNode(true));
  frame.toggleAttribute('data-cw-gallery', card.hasAttribute('data-cw-card'));
  modal.querySelector('[data-iam-details]').href = `${productURL(card.dataset.handle)}?color=${encodeURIComponent(card.dataset.color)}`;
  modal.dataset.handle = card.dataset.handle;
  modal.showModal();
  try {
    const product = await productData(card.dataset.handle);
    if (modal.dataset.handle !== card.dataset.handle || !modal.open) return;
    if (card.hasAttribute('data-iam-product') && !card.querySelector('[data-cw-gallery]')) {
      const catalog = await catalogPromise;
      if (modal.dataset.handle !== card.dataset.handle || !modal.open) return;
      const entry = catalog.items.find(item => item.handle === product.handle);
      if (entry) frame.replaceChildren(makePhoto(entry, color || entry.color, catalog));
    }
    const choices = form.querySelector('.iam-christmas-color-options');
    const template = choices.querySelector('label').cloneNode(true);
    choices.replaceChildren();
    for (const name of new Set(product.variants.map(v => v.option1))) {
      const label = template.cloneNode(true);
      label.querySelector('input').value = name;
      label.querySelector('span').textContent = name;
      choices.append(label);
    }
    setupForm(modal,product,color || product.variants[0].option1);
  } catch (e) { form.querySelector('[data-iam-error]').textContent = config.dataset.error; }
}

export async function openProductQuickAdd(productPage, variantId) {
  const product = await productData(productPage.dataset.handle);
  const variant = product.variants.find(item => String(item.id) === String(variantId));
  await openQuick(productPage, variant?.option1 || product.variants[0].option1);
}

document.addEventListener('click', async event => {
  const quick = event.target.closest('[data-iam-quick]');
  if (quick) {openQuick(quick.closest('.iam-christmas-card, [data-iam-product]'));return;}
  if (event.target.closest('[data-iam-close]')) {modal.close();return;}
  const swatch = event.target.closest('[data-iam-color]');
  if (!swatch) return;
  const card = swatch.closest('.iam-christmas-card');
  card.dataset.color = swatch.dataset.iamColor;
  card.querySelectorAll('[data-iam-color]').forEach(el=>el.setAttribute('aria-pressed',String(el===swatch)));
  card.querySelectorAll('a').forEach(a=>a.href=`${productURL(card.dataset.handle)}?color=${encodeURIComponent(card.dataset.color)}`);
  try {await updatePhoto(card,card.dataset.color);} catch (e) {}
});

document.addEventListener('submit', async event => {
  const form = event.target.closest('[data-iam-buy]');
  if (!form) return;
  event.preventDefault();
  if (!form.reportValidity() || !form.product || form.dataset.busy) return;
  const variant = selectedVariant(form,form.product);
  if (!variant?.available) return;
  const button = form.querySelector('[type="submit"]');
  const error = form.querySelector('[data-iam-error]');
  form.dataset.busy = 'true'; button.disabled = true;button.textContent = config.dataset.adding;error.textContent = '';
  const items = [{id:variant.id,quantity:1}];
  const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el=>el.dataset.sectionId).filter(Boolean))].slice(0,5);
  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:items.map(x=>({merchandiseId:String(x.id),quantity:x.quantity})),promise:deferred.promise}));
  let committed = false;
  try {
    const response = await fetch(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:sections.join(','),sections_url:location.pathname+location.search})});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || config.dataset.error);
    committed = true;
    const cartResponse = await fetch(`${root}cart.js`);
    if (!cartResponse.ok) throw new Error('Cart refresh unavailable');
    const cart = await cartResponse.json();
    deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:'iam-christmas-quick-add',itemCount:items.length,productId:String(form.product.id),sections:result.sections,didError:false}});
    if (modal.open) modal.close();
    if (!document.querySelector('#cart-drawer')) location.assign(`${root}cart`);
  } catch (e) {
    deferred.reject(e);
    if (committed) {location.assign(`${root}cart`);return;}
    error.textContent = e.message || config.dataset.error;
  } finally {delete form.dataset.busy;button.disabled=false;button.textContent=config.dataset.add;}
});

const page = document.querySelector('[data-iam-product]');
if (page) {
  try {
    const [catalog,product] = await Promise.all([catalogPromise,productData(page.dataset.handle)]);
    const item = catalog.items.find(x=>x.handle===page.dataset.handle);
    const params = new URLSearchParams(location.search);
    const fromVariant = product.variants.find(v=>String(v.id)===params.get('variant'));
    const requestedColor = fromVariant?.option1 || params.get('color') || item?.color || product.variants[0].option1;
    const color = page.querySelector('[data-cw-gallery]') ? (product.variants.some(v => v.option1 === requestedColor) ? requestedColor : product.variants[0].option1) : (Object.hasOwn(catalog.bases,requestedColor) ? requestedColor : item?.color || product.variants[0].option1);
    if (item && !page.querySelector('[data-cw-gallery]')) page.querySelector('[data-iam-product-photo]').replaceChildren(makePhoto(item,color,catalog));
    setupForm(page,product,color);
    if (fromVariant) {page.querySelector('form').elements.size.value=fromVariant.option2;page.querySelector('form').onchange();}
  } catch (e) {page.querySelector('[data-iam-error]').textContent=config.dataset.error;}
}

document.addEventListener('click', event => {
  const choice = event.target.closest('[data-cw-image]');
  if (!choice) return;
  const card = choice.closest('[data-cw-card]');
  card.dataset.color = choice.title;
  const image = card.querySelector('img');
  image.removeAttribute('srcset');
  image.src = choice.dataset.cwImage;
  image.alt = card.querySelector('h3').textContent + ' – ' + choice.title;
  card.querySelectorAll('a').forEach(a => a.href = choice.dataset.cwUrl);
  card.querySelectorAll('[data-cw-image]').forEach(b => b.setAttribute('aria-pressed', String(b === choice)));
});
